import React, { useState } from "react";
import { ABtn, AResult, AScore, AHint } from "./arcadeUi";
import { sfx } from "@/lib/soundfx";

// classic rule: last digit of the page number = runs, a 0 means OUT
const flipPage = () => { const page = 1 + Math.floor(Math.random() * 300); return { page, runs: (page % 10) % 7 }; };

export default function BookCricket() {
  const [phase, setPhase] = useState("you"); // you -> cpu -> over
  const [your, setYour] = useState(0);
  const [cpu, setCpu] = useState(0);
  const [target, setTarget] = useState(null);
  const [runs, setRuns] = useState(null);
  const [page, setPage] = useState(null);
  const [flipId, setFlipId] = useState(0);
  const [msg, setMsg] = useState("Your innings — flip the book!");

  const reset = () => { setPhase("you"); setYour(0); setCpu(0); setTarget(null); setRuns(null); setPage(null); setMsg("Your innings — flip the book!"); };

  const doFlip = () => {
    const { page: pg, runs: r } = flipPage();
    setRuns(r); setPage(pg); setFlipId((id) => id + 1); sfx.flip();
    if (phase === "you") {
      if (r === 0) { const t = your + 1; setTarget(t); setPhase("cpu"); setMsg(`OUT on ${your}! CPU needs ${t}. Flip for CPU.`); }
      else { setYour((v) => v + r); setMsg(`${r} runs!`); }
    } else if (phase === "cpu") {
      if (r === 0) { setPhase("over"); setMsg(`CPU out on ${cpu}.`); }
      else {
        const nc = cpu + r;
        setCpu(nc);
        if (nc >= target) { setPhase("over"); setMsg("CPU chased it!"); }
        else setMsg(`CPU: ${r} runs`);
      }
    }
  };

  const won = phase === "over" ? (target != null && cpu < target) : null;

  return (
    <div className="w-full text-center">
      <div className="flex justify-center gap-2">
        <AScore label="You" value={your} />
        <AScore label="CPU" value={cpu} />
        {target != null && <AScore label="Target" value={target} />}
      </div>
      <AHint>{phase === "you" ? "📖 You are batting" : phase === "cpu" ? "📖 CPU batting (you flip)" : "Match over"}</AHint>
      <p data-testid="bc-msg" className="min-h-[1.5rem] font-signboard text-lg text-kirana-brown">{msg}</p>

      <div className="my-4 flex flex-col items-center gap-1">
        <div className="relative flex h-28 w-40 items-end justify-center overflow-hidden rounded-md border-[3px] border-kirana-brown bg-gradient-to-br from-[#f5e6c8] to-[#dcc292] shadow-inner" data-testid="bc-book">
          {/* page lines */}
          <div className="pointer-events-none absolute inset-0 opacity-30" style={{ background: "repeating-linear-gradient(#00000010 0 1px, transparent 1px 9px)" }} />
          <div className="absolute left-1/2 top-0 h-full w-[2px] -translate-x-1/2 bg-black/15" />
          {runs == null ? (
            <span className="mb-6 font-signboard text-4xl">📖</span>
          ) : (
            <div key={flipId} className={`bc-roll-in mb-4 font-signboard text-6xl font-bold ${runs === 0 ? "text-kirana-red" : "text-kirana-brown"}`} data-testid="bc-runs">
              {runs === 0 ? "OUT" : runs}
            </div>
          )}
        </div>
        <span className="text-xs font-bold text-kirana-brown/60" data-testid="bc-page">{page != null ? `page ${page}` : "flip to open a page"}</span>
      </div>

      {phase !== "over" ? (
        <ABtn data-testid="bc-flip" onClick={doFlip} tone="red" className="px-8 py-3 text-lg">Flip the Book 📖</ABtn>
      ) : (
        <>
          <AResult testId="bc-result" win={won} text={won ? "🏆 You Won!" : "😜 CPU Won"} />
          <div className="mt-3 flex justify-center"><ABtn data-testid="bc-again" onClick={reset} tone="green">Play Again</ABtn></div>
        </>
      )}
    </div>
  );
}
